/* eslint-disable */
import swr from 'swr';
import * as api from './api';

import { getJwtUserData } from '@/utils/auth';

type Endpoint = string | (() => string);

const getEndpoint = (endpoint: Endpoint) =>
  typeof endpoint === 'function' ? endpoint() : endpoint;

const mutateOptions = {
  revalidate: true,
  populateCache: true,
  rollbackOnError: true,
};
export async function fetcher(url: string) {
  const { token } = getJwtUserData();

  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!res.ok) {
    throw new Error("Error while fetching " + res.statusText);
  }
  return res.json();
}
export const get = (endpoint: Endpoint) =>
  swr(getEndpoint(endpoint), (url) => api.get(url), {
    revalidateOnFocus: false,
  });

const mutatingFetch = (
  apiFn: (url: string, payload: any) => Promise<any>,
  endpoint: Endpoint,
  payload: any = {},
  mutate?: (...arg: any) => any
) => {
  const updater = () => apiFn(getEndpoint(endpoint), payload);
  return typeof mutate === 'function'
    ? mutate(updater(), { ...mutateOptions, optimisticData: payload })
    : updater();
};

export const post = (endpoint: Endpoint, payload: any, mutate?: any) =>
  mutatingFetch(api.post, endpoint, payload, mutate);

export const put = async (endpoint: Endpoint, payload: any, mutate?: any) =>
  mutatingFetch(api.put, endpoint, payload, mutate);

export const fetchDelete = (endpoint: Endpoint, payload: any, mutate?: any) =>
  mutatingFetch(api.fetchDelete, endpoint, payload, mutate);

/* eslint-enable */
